import { useEffect, useState, useRef } from "react";
import { Input, message } from "antd";
import axios from "axios";
import { API, Headers } from "../../Config";
import PageHeader from "../../Routes/PageHeader";
import LoadingBox from "../../Components/LoadingBox";
import DataTable from "./components/dataTable";
import SalesForm from "./components/formModal";
import { useSelector } from "react-redux";

const Sales = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [selectedSale, setSelectedSale] = useState(null);
  const [page, setPage] = useState(1);
  const [take, setTake] = useState(10);
  const [meta, setMeta] = useState({});
  const [openForm, setOpenForm] = useState(false);
  const [search, setSearch] = useState("");
  const [expandedRowKeys, setExpandedRowKeys] = useState([]);
  const isMounted = useRef(true);
  const Auth = useSelector((state) => state.Auth.user);

  useEffect(() => {
    isMounted.current = true;
    loadData(page, take, search);
    fetchAccounts();

    return () => {
      isMounted.current = false;
    };
  }, [page, take, search]);

  const fetchAccounts = async () => {
    try {
      const response = await axios.get(
        `${API.BASR_URL}${API.CHART_OF_ACCOUNTS_LIST}/child_accounts`,
        { headers: Headers() }
      );
      if (isMounted.current && response.status === 200) {
        setAccounts(response.data);
      }
    } catch (error) {
      if (isMounted.current) {
        message.error("Failed to load accounts");
      }
    }
  };

  const loadData = async (p, t, searchTerm) => {
    setLoading(true);
    try {
      const url = `${API.BASR_URL}${API.SALE}/?userid=${Number(
        Auth?.id
      )}&order=DESC&page=${p}&take=${t}${
        searchTerm ? `&search=${encodeURIComponent(searchTerm)}` : ""
      }`;
      const response = await axios.get(url, { headers: Headers() });
      if (isMounted.current && response.status === 200) {
        setData(response.data.data);
        setMeta(response.data.meta);
        setExpandedRowKeys(
          searchTerm ? response.data.data.map((item) => item.id) : []
        );
      } else if (isMounted.current) {
        message.error("Failed to load sales");
      }
    } catch (error) {
      if (isMounted.current) {
        message.error("Failed to load sales");
      }
    } finally {
      if (isMounted.current) {
        setLoading(false);
      }
    }
  };

  const handleDelete = async (item) => {
    try {
      await axios.delete(`${API.BASR_URL}${API.SALE}/${item.id}`, {
        headers: Headers(),
      });
      if (isMounted.current) {
        message.success("Deleted successfully");
        loadData(page, take, search);
      }
    } catch (error) {
      if (isMounted.current) {
        message.error("Failed to delete sale");
      }
    }
  };

  const handleEdit = (item) => {
    setSelectedSale(item);
    setOpenForm(true);
    fetchAccounts();
  };

  const handleFormToggle = () => {
    setOpenForm(!openForm);
    setSelectedSale(null);
  };

  const handleSearch = (value) => {
    setSearch(value);
    setPage(1);
  };

  const handleTableChange = (p, t) => {
    setPage(p);
    setTake(t);
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <PageHeader
        breadScrum="Admin / Sales"
        RightButton="New / Sales"
        RightClcik={handleFormToggle}
      />
      <div
        style={{
          marginBottom: 16,
          display: "flex",
          justifyContent: "flex-end",
        }}
      >
        <Input.Search
          placeholder="Search by box Number"
          onSearch={handleSearch}
          onChange={(e) => handleSearch(e.target.value)}
          allowClear
          style={{ width: 300 }}
        />
      </div>
      {loading ? (
        <LoadingBox />
      ) : (
        <div>
          <DataTable
            data={data}
            meta={meta}
            onDelete={handleDelete}
            onUpdate={handleEdit}
            Onchange={handleTableChange}
            expandedRowKeys={expandedRowKeys}
            setExpandedRowKeys={setExpandedRowKeys}
          />
          {openForm && (
            <SalesForm
              data={data}
              accounts={accounts}
              visible={openForm}
              relaod={() => loadData(page, take, search)}
              selectedPurchase={selectedSale}
              onClose={handleFormToggle}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Sales;
